import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import utils from '../../../utils/validateScanner.js'
import Printd from 'printd'
import { nudgeBus } from '@/utils/nudgeBus'

export default {
	name: 'confirm-line-haul-connection',
	mixins: [utils],
	watch: {
		isPaperworkShortageEnabled: function(enabled) {
			if (!enabled && this.activeTab === 'parentAwb') {
				this.activeTab = 'shipment';
			}
		},
	},
	components: {
		Paginate,
		DatePicker,
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {
			activeTab: 'shipment',
			hubName: "",
			showTable: false,
			isLoadingSearch: false,
			isLoading: false,
			isDisplay: true,
			shippingid: "",
			shipmentDetails: {
				shippingid: "",
				shipmentstatus: "",
				status: ""
			},
			ConfirmShipmentShortage: false,
			isDisabledOK: false,
			centerType:'',
			parentawb: '',
			parentAwbError: false,
			confirmParentAwbShortage: false,
			isDisabledParentAwbOK: false
		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.hubId = userdetail[0].HubId[0];
		this.getHubName(userdetail[0].HubId);
		this.hubForManualRestriction();

	},
	methods: {
		switchTab(tab) {
			this.activeTab = tab;
		},
		getHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubName = result.data.ResponseData[0].HubName;
						this.centerType = result.data.ResponseData[0].CenterType;

					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},
		onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						return false;
					} else {
						this.loadShipmentDetails();
					}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},
		loadShipmentDetails() {
			this.isLoadingSearch = true
			this.input = {}
			axios({
					method: 'GET',
					url: apiUrl.allocateRuleapi_url + 'getShipmentDetailsForShortage?flow=markShortage&ShippingID=' + this.shippingid,
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					var response = result.data
					if (response.ResultCode == 100) {
						// PXB-7142 Shipment Color Code & Icon
					if(Object.keys(response.lossCategorization).length !=0){
						this.colorCode = response.lossCategorization.colorCode;
						this.colorIcon = response.lossCategorization.icon;
								  }
						if (response.ResponseData) {
							this.isLoadingSearch = false;
							this.showTable = true;
							this.shipmentDetails = response.ResponseData;
						}
					} else {
						this.shipmentDetails = {};
						this.isLoadingSearch = false;
						this.showTable = false;
						this.$alertify.error(result.data.ReturnMessage)
						this.showHideCodeIconInput();
					}
					this.isLoading = false
				}, error => {
					console.log(error)
					this.showHideCodeIconInput();
				})
		},
		openParentAwbShortageConfirm() {
			if (!this.parentawb || !this.parentawb.trim()) {
				this.parentAwbError = true;
				return;
			}
			this.parentAwbError = false;
			this.confirmParentAwbShortage = true;
		},
		ConfirmShipmentShortageMark() {
			this.ConfirmShipmentShortage = true;
		},
		CloseConfirmation() {
			this.ConfirmShipmentShortage = false;
		},
		closeParentAwbConfirmation() {
			this.confirmParentAwbShortage = false;
		},
		MarkShipmentShortage(shipmentDetails) {
			this.isDisabledOK = true
			this.input = ({
				"processLocation": this.hubId,
				"shipmentStatus": shipmentDetails.shipmentstatus,
				"status": shipmentDetails.status,
				"lastModifiedBy": this.useremail,
				"shippingId": shipmentDetails.shippingid,
				"isManualEntry":false,
				"shipmentCurrentHub":shipmentDetails.currenthubid,
				"centerType":this.centerType
			});
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'markShipmentShortage',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isDisabledOK = false
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage)
						if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
						this.ConfirmShipmentShortage = false;
						this.resetForm()
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.ConfirmShipmentShortage = false;

					}
				}, error => {
					console.error(error)
				})
		},
		markParentAwbShortage() {
			this.isDisabledParentAwbOK = true;
			this.input = ({
				parentawb: this.parentawb.trim(),
				paperworkcurrenthubid: Number(this.hubId),
				createdby: this.useremail,
				statusmarkedfrom: 'Web'
			});
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'markParentAwbShortage',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'Content-Type': 'application/json'
					}
				})
				.then(result => {
					this.isDisabledParentAwbOK = false;
					const resultCode = result.data.ReturnCode != null ? result.data.ReturnCode : result.data.ResultCode;
					if (resultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage);
						if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
						this.confirmParentAwbShortage = false;
						this.resetParentAwbForm();
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.confirmParentAwbShortage = false;
					}
				}, error => {
					this.isDisabledParentAwbOK = false;
					console.error(error);
					this.$alertify.error('API Error');
				});
		},
		resetForm() {
			this.isDisabledOK = false
			this.shippingid = "";
			this.shipmentDetails = {};
			this.isLoadingSearch = false;
			this.showTable = false;
			this.$validator.reset();
			this.errors.clear();
			this.showHideCodeIconInput();
		},
		resetParentAwbForm() {
			this.isDisabledParentAwbOK = false;
			this.parentawb = '';
			this.parentAwbError = false;
			this.confirmParentAwbShortage = false;
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/MarkShipmentShortage/MarkShipmentShortage.js